import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UnitService } from 'src/app/services/unit.service';
import { UtilsService } from 'src/app/services/utils.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-checklist-unit',
    templateUrl: './checklist-unit.component.html',
    styleUrls: ['./checklist-unit.component.css']
})


export class ChecklistUnitComponent {
    dataUser: any = {}
    unit: any = {}
    tires: any = []
    positions = ['1I','1D','2I-INT','2I-EXT','2D-INT','2D-EXT','3I-INT','3I-EXT','3D-INT','3D-EXT']
    constructor(
        private checklistService: UnitService, 
        private location: Location, 
        private utils: UtilsService, 
        private spinner: NgxSpinnerService, 
        private router: Router
    ) { }
    async ngOnInit(): Promise<void> {
        // this.spinner.show()
        let unit: any = this.location.getState()
        this.dataUser = this.utils.getDataUser()
        this.unit = unit.data
        this.data.unit_id = this.unit.id
        this.data.user_id = this.dataUser.id
        
        // Load saved data from localStorage
        await this.loadFromLocalStorage();
    }
    data: any = {
        // Motor
        oil_level: false,
        oil_leaks: false,
        antifreeze_level: false,
        hoses_in_good_condition: false,
        water_pump: false,
        belts_in_good_condition: false,
        battery_correct: false,

        // Frenos
        brake_fluid_level: false,
        brake_pedal: false,
        parking_brake: false,
        brake_lineLeaks: false,
        brake_pump: false,
        brake_no_noise: false,

        // Suspensión y dirección
        shock_absorbersLeaks: false,
        shock_absorbers_no_jumps: false,
        steering_sin_juego: false,
        steering_boxLeaks: false,
        steering_bushes_in_good_condition: false,

        // Llantas
        number_tires: '',
        number_repair: '',
        repair_optimal: false,

        // Kilometraje
        date: '',
        mileage: '',

        // Interior y cabina
        seats_in_good_condition: false,
        radio: false,
        seat_belts: false,
        air_conditioning: false,
        windows: false,
        locks: false,

        // seguridad y herramientas
        fire_extinguisher: false,
        hydraulic_jack: false,
        lug_wrench_or_crosshead_wrench: false,
        reflective_triangles: false,

        // Documentacion
        vehicle_registration: false,
        current_insurance: false,
        vehicle_verification: false,
    };

    evidencias: Record<string, string[]> = {};
    evidenciasFiles: Record<string, File[]> = {};
    
    private readonly STORAGE_KEY_PREFIX = 'checklist_unit_data_';

    // Get storage key specific to this unit
    private getStorageKey(): string {
        return this.STORAGE_KEY_PREFIX + (this.unit?.id || 'unknown');
    }

    onNumberTiresChange() {
        const numberOfTires = parseInt(this.data.number_tires) || 0;
        this.tires = [];
        
        for (let i = 0; i < numberOfTires; i++) {
            this.tires.push({
                brand: '',
                model: '',
                dot: '',
                pressure: '',
                millimeters: '',
                mileage: '',
                axis: '',
                position: '',
                pressure_correct: false,
                tire_no_punctures: false,
                tire_complete: false
            });
        }
        
        // Save to localStorage after changing tire count
        this.saveToLocalStorage();
    }

    getFilteredPositions(axis: string): string[] {
        if (!axis || axis === '') return this.positions;
        return this.positions.filter(p => p.includes(axis.toString()));
    }

    onFileChange(event: any, categoria: string) {
        if (!this.evidencias[categoria]) {
            this.evidencias[categoria] = [];
            this.evidenciasFiles[categoria] = [];
        }
        
        const files = Array.from(event.target.files) as File[];
        const currentCount = this.evidencias[categoria].length;
        const maxImages = 4;
        
        // Check if adding new files would exceed the limit
        if (currentCount + files.length > maxImages) {
            const remainingSlots = maxImages - currentCount;
            if (remainingSlots <= 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Límite alcanzado',
                    text: `Solo puedes subir máximo ${maxImages} imágenes por categoría. Ya tienes ${currentCount} imágenes.`,
                });
                // Clear the input
                event.target.value = '';
                return;
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Límite de imágenes',
                    text: `Solo puedes subir ${remainingSlots} imagen(es) más. Máximo ${maxImages} imágenes por categoría.`,
                });
                // Clear the input
                event.target.value = '';
                return;
            }
        }
        
        files.forEach(file => {
            const url = URL.createObjectURL(file);
            this.evidencias[categoria].push(url);
            this.evidenciasFiles[categoria].push(file);
        });
        
        // Clear the input to allow selecting the same files again if needed
        event.target.value = '';
        
        // Save to localStorage after adding files
        this.saveToLocalStorage();
    }

    enviar() {
        // Validar que todas las evidencias sean obligatorias
        const categoriasEvidencia = [
            { name: 'engine', label: 'Motor' }, 
            { name: 'brakes', label: 'Frenos' }, 
            { name: 'suspension', label: 'Suspensión y dirección' }, 
            { name: 'repair', label: 'Refacciones' }, 
            { name: 'mileage', label: 'Kilometraje' },
            { name: 'front', label: 'Frontal' },
            { name: 'front_left', label: 'Frontal izquierda (3/4)' },
            { name: 'front_right', label: 'Frontal derecha (3/4)' },
            { name: 'side_left', label: 'Lateral izquierda' },
            { name: 'side_right', label: 'Lateral derecha' },
            { name: 'full_rear', label: 'Trasera completa' },
            { name: 'inside', label: 'Interior caja' },
            { name: 'interior_and_cabin', label: 'Interior y cabina' }
        ];
        for (let i = 0; i < this.tires.length; i++) {
            categoriasEvidencia.push({ name: 'tires_' + (i+1), label: 'Llanta ' + (i+1) });
        }


        const categoriasFaltantes: string[] = [];

        categoriasEvidencia.forEach(categoria => {
            if (!this.evidenciasFiles[categoria.name] || this.evidenciasFiles[categoria.name].length === 0) {
                categoriasFaltantes.push(categoria.label);
            }
        });

        if (categoriasFaltantes.length > 0) {
            const categoriasTexto = categoriasFaltantes.join(', ');
            Swal.fire({
                icon: 'warning',
                text: 'Por favor suba evidencia para las siguientes categorías: ' + categoriasTexto,
            });
            return;
        }

        this.data.tires = JSON.stringify(this.tires);

        this.spinner.show()
        this.checklistService.crearChecklist(this.data, this.evidenciasFiles).subscribe({
            next: () => {
                this.spinner.hide()
                // Clear localStorage after successful submission
                this.clearLocalStorage();
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Checklist creado correctamente',
                }).then(() => {
                    this.router.navigate(['/unit'])
                })
            },
            error: err => {
                this.spinner.hide()
                console.error('Error al enviar checklist:', err)
            }
        });
    }
    removeFile(index: number, categoria: string) {
        const url = this.evidencias[categoria][index];
        if (url) {
            URL.revokeObjectURL(url); // Clean up the blob URL to free memory
        }
        this.evidencias[categoria].splice(index, 1);
        this.evidenciasFiles[categoria].splice(index, 1);
        
        // Save to localStorage after removing file
        this.saveToLocalStorage();
    }

    // Convert File to base64 for localStorage
    private fileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = error => reject(error);
        });
    }

    // Convert base64 back to File
    private base64ToFile(base64: string, filename: string): File {
        const arr = base64.split(',');
        const mime = arr[0].match(/:(.*?);/)![1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    // Save all data to localStorage
    async saveToLocalStorage() {
        try {
            const dataToSave: any = {
                data: { ...this.data },
                tires: [...this.tires],
                evidenciasBase64: {} as Record<string, Array<{base64: string, filename: string}>>
            };

            // Convert files to base64
            for (const categoria in this.evidenciasFiles) {
                if (this.evidenciasFiles[categoria].length > 0) {
                    dataToSave.evidenciasBase64[categoria] = [];
                    for (const file of this.evidenciasFiles[categoria]) {
                        const base64 = await this.fileToBase64(file);
                        dataToSave.evidenciasBase64[categoria].push({
                            base64: base64,
                            filename: file.name
                        });
                    }
                }
            }

            localStorage.setItem(this.getStorageKey(), JSON.stringify(dataToSave));
        } catch (error) {
            console.error('Error al guardar en localStorage:', error);
        }
    }

    // Load data from localStorage
    async loadFromLocalStorage() {
        try {
            const savedData = localStorage.getItem(this.getStorageKey());
            if (savedData) {
                const parsedData = JSON.parse(savedData);
                
                // Restore form data
                this.data = { ...this.data, ...parsedData.data };
                
                // Restore tires data
                if (parsedData.tires) {
                    this.tires = [...parsedData.tires];
                }

                // Restore evidencias from base64
                if (parsedData.evidenciasBase64) {
                    for (const categoria in parsedData.evidenciasBase64) {
                        this.evidencias[categoria] = [];
                        this.evidenciasFiles[categoria] = [];
                        
                        for (const fileData of parsedData.evidenciasBase64[categoria]) {
                            // Convert base64 back to File
                            const file = this.base64ToFile(fileData.base64, fileData.filename);
                            const url = URL.createObjectURL(file);
                            
                            this.evidencias[categoria].push(url);
                            this.evidenciasFiles[categoria].push(file);
                        }
                    }
                }
                
                // Show notification to user
                Swal.fire({
                    icon: 'info',
                    title: 'Datos restaurados',
                    text: `Se han cargado los datos guardados para la unidad ${this.unit?.unit || 'desconocida'} (${this.unit?.plates || 'sin placas'}).`,
                    timer: 4000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            console.error('Error al cargar desde localStorage:', error);
        }
    }

    // Clear localStorage
    clearLocalStorage() {
        localStorage.removeItem(this.getStorageKey());
    }

    // Method to handle form data changes and auto-save
    onFormDataChange() {
        // Debounce the save operation to avoid too many saves
        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }
        this.saveTimeout = setTimeout(() => {
            this.saveToLocalStorage();
        }, 1000); // Save after 1 second of inactivity
    }

    private saveTimeout: any;
}
